// @flow

"use strict";

 /**
 * Dom操作ユーティリティクラス
 */
export default class DomUtil {

  /**
   * 指定した要素にIDを付与
   * @param element dom要素
   * @param idName 付与するid名
   * @returns {boolean}
   */
  static addId(element: HTMLElement, idName: string): boolean {
    element.id = idName;
    return true;
  }

   /**
    * 指定した要素に{idName}が指定されているかどうか
    * @param element
    * @param idName
    * @returns {boolean}
    */
  static hasId(element: HTMLElement, idName: string): boolean {
    const id = element.id;
    if(!id){
      return false;
    }
    return id === idName;
  }

   /**
    * 指定した要素からclassを付与
    * @param element
    * @param className
    * @returns {boolean}
    */
  static addClass(element: HTMLElement, className: string): boolean {
    if(!DomUtil.hasClass(element, className)){
      const classArray = element.className.split(' ');
      classArray.push(className);
      element.className = classArray.join(' ');
      return true;
    }

    return false;
  }

  /**
   * 指定した要素にclassが存在しているか判定
   * @param element
   * @param className
   * @returns {boolean}
   */
  static hasClass(element: HTMLElement, className: string): boolean {
    if(!element.className){
      return false;
    }
    return (' ' + element.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + className + ' ') !== -1;
  }

   /**
    * 指定した要素からclassを除去
    * @param element dom要素
    * @param className 削除するクラス名
    * @returns {boolean}
    */
  static removeClass(element: HTMLElement, className: string): boolean {
    if(!element.className){
      return false;
    }
    let classArray = element.className.split(' ');
    const index = classArray.indexOf(className);
    if (index >= 0) {
      classArray.splice(index, 1);
      element.className = classArray.join(' ');
      return true;
    }

    return false;
  }

  static findChildElementByAttribute(parentElement: HTMLElement, attribute: string): HTMLElement {
    for(let child=parentElement.firstElementChild; child!==null; child=child.nextSibling) {
      if (child.hasAttribute(attribute)){
        return child;
      }
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dom-util.js